import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export const useAdminData = () => {
    const getAdminData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}admin${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postAdminData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}admin${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}admin${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putAdminData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}admin${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchAdminData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}admin${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteAdminData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}admin${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getAdminData,
        postAdminData,
        putAdminData,
        patchAdminData,
        deleteAdminData
    };

};